import { useListContext, useTranslate } from 'react-admin';
import { BarChartWithTrend } from '@/components/analytics/common/BarChartWithTrend.jsx';
import { formatTimeInterval } from '@/helpers/date/formatTimeInterval.js';
import { prepareTrendChartData } from '@/helpers/analytics/charts.js';
import { formatWeight } from '@/helpers/format/formatNumber.js';
import { ChartAnalyticsCard } from '@/components/analytics/common/ChartAnalyticsCard.jsx';
import { AnalyticsChartTitle } from '@/components/analytics/common/AnalyticsChartTitle.jsx';
import { AnalyticsChartSubtitle } from '@/components/analytics/common/AnalyticsChartSubtitle.jsx';

export const CollectedBagsAnalytics = () => {
    const { data } = useListContext();
    const translate = useTranslate();

    if (!data || data.length === 0) return null;
    const analytic = data[0].data;
    const previous = data[1].data;

    const series = data.find(s => s.id === 'series').data;
    let chartData = prepareTrendChartData(series, 'bagsCount');
    let avgFillingTime =
        0 !== analytic.bagsCount || 0 !== analytic.bagsFillingTimeSum ? formatTimeInterval(analytic.bagsFillingTimeSum / analytic.bagsCount) : null;

    return (
        <ChartAnalyticsCard
            barHeight={347}
            data={chartData}
            dataKey='bagsCount'
            stats={
                <>
                    <AnalyticsChartTitle
                        title={translate('analytics.container.collected')}
                        value={analytic.bagsCount}
                        growth={((analytic.bagsCount - previous.bagsCount) / previous.bagsCount) * 100}
                    />
                    <AnalyticsChartSubtitle label={translate('analytics.container.weight')} value={formatWeight(analytic.transactionsWeightSum)} />
                    <AnalyticsChartSubtitle
                        label={translate('analytics.container.avgWeight')}
                        value={formatWeight(analytic.transactionsWeightSum / analytic.bagsCount)}
                    />
                    <AnalyticsChartSubtitle label={translate('analytics.container.avgFillingTime')} value={avgFillingTime} />
                </>
            }
            chart={<BarChartWithTrend data={chartData} dataKey='bagsCount' label={translate('analytics.container.collectedCount')} />}
        />
    );
};
